<template>
  <div class="p-24 px-8 bg-gray-100 max-w-5xl rounded-xl m-auto">
    <div class="fixed z-[10000] w-full h-full top-0 left-0 flex items-center justify-center" v-if="isCompleted && isValid">
      <div class="fixed w-full h-full bg-gray-500 opacity-50"></div>
      <div class="relative z-2 w-full xs:w-full md:w-1/3 bg-white p-8 mx-auto rounded-xl flex flex-col items-center">
        <p class="text-xl pb-4">Brawo, udało Ci się prawidłowo przydzielić obrazki do pól!</p>
        <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4" @click="startGame">Zagraj ponownie</button>
      </div>
    </div>
    <div v-if="started === false">
      <h2 class="text-3xl text-center block">Grupowanie</h2>
      <p class="text-lg text-center mt-2 text-gray-500">Umieść obrazek w odpowiednim polu</p>
      <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4 mx-auto" @click="startGame">Rozpocznij grę</button>
    </div>
    <div v-else>
      <span class="text-2xl text-center block" v-if="selectedGame">{{ selectedGame.topic }}</span>
      <p class="text-lg text-center mt-2 text-gray-500">{{ selectedGame.subtitle ?? "Umieść obrazek w odpowiednim polu"}}</p>
      <div class="mt-4">
        <div class="grid grid-cols-2 gap-4 mt-4">
          <div :class="{ 'positive bg-white rounded-xl p-8 text-center game-items': true, 'dragging': isDragging, 'no-items': items.positive.length === 0 && !('images' in selectedGame)}">
            <img v-if="selectedGame.images && selectedGame.images.positive" :src="selectedGame.images.positive" class="w-24 mx-auto mb-5"/>
            <span class="text-xl block mb-5">{{ selectedGame.titles.positive }}</span>
            <draggable v-model="items.positive" group="items" item-key="id" v-bind="dragOptions" @start="isDragging = true" @end="isDragging = false">
              <template #item="{element}">
                <img :src="`${baseUrl}images/grouping/${difficult}/${element.id}.png`" class="inline-block w-32"/>
              </template>
            </draggable>
          </div>
          <div :class="{ 'negative bg-white rounded-xl p-8 text-center game-items': true, 'dragging': isDragging, 'no-items': items.negative.length === 0 && !('images' in selectedGame)}">
            <img v-if="selectedGame.images && selectedGame.images.negative" :src="selectedGame.images.negative" class="w-24 mx-auto mb-5"/>
            <span class="text-xl block mb-5">{{ selectedGame.titles.negative }}</span>
            <draggable v-model="items.negative" group="items" item-key="id" v-bind="dragOptions" @start="isDragging = true" @end="isDragging = false">
              <template #item="{element}">
                <img :src="`${baseUrl}images/grouping/${difficult}/${element.id}.png`" class="inline-block w-32"/>
              </template>
            </draggable>
          </div>
        </div>
        <div class="w-full text-center mt-10" v-if="isCompleted && isValid === false">
          <span class="text-2xl text-center text-red-500 block">Wygląda na to, że źle rozdzieliłeś obrazki do pól.<br>Sprawdź dokładniej!</span>
        </div>
        <div class="w-full text-center mt-10">
          <draggable v-model="items.all" group="items" item-key="id" v-bind="dragOptions" @start="isDragging = true" @end="isDragging = false">
            <template #item="{element}">
              <img :src="`${baseUrl}images/grouping/${difficult}/${element.id}.png`" class="inline-block w-32"/>
            </template>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {getRandomOtherThan} from "@/helpers";

const Type = {
  Positive: 'positive',
  Negative: 'negative'
}

export default {
  components: {
    draggable
  },
  props: {
    difficult: {
      type: String,
      default: (() => '1-4')
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      started: false,
      isDragging: false,
      gameIndex: 0,
      items: {
        all: [],
        positive: [],
        negative: []
      },
      games: {
        'przedszkola': [
          {
            topic: "Segregacja odpadów",
            subtitle: "Przyporządkuj śmieci do odpowiedniego śmietnika",
            titles: {
              positive: "Kosz zielony",
              negative: "Kosz żółty"
            },
            images: {
              positive: `${process.env.BASE_URL}images/grouping/ikony-koszy-06.png`,
              negative: `${process.env.BASE_URL}images/grouping/ikony-koszy-07.png`,
            },
            items: [
              { id: 'segregacja/1', answer: Type.Negative },
              { id: 'segregacja/2', answer: Type.Negative },
              { id: 'segregacja/3', answer: Type.Negative },
              { id: 'segregacja/4', answer: Type.Negative },
              { id: 'segregacja/5', answer: Type.Negative },
              { id: 'segregacja/6', answer: Type.Positive },
              { id: 'segregacja/7', answer: Type.Positive },
              { id: 'segregacja/8', answer: Type.Positive },
              { id: 'segregacja/9', answer: Type.Positive },
              { id: 'segregacja/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Ekouprawy",
            subtitle: "Pogrupuj owoce i warzywa na te, które rosną w naszych ogródkach i te które przyjeżdżają do nas z innych krajów",
            titles: {
              positive: "Nasze ogródki",
              negative: "Z zagranicy"
            },
            items: [
              { id: 'ekouprawy/1', answer: Type.Positive },
              { id: 'ekouprawy/2', answer: Type.Positive },
              { id: 'ekouprawy/3', answer: Type.Positive },
              { id: 'ekouprawy/4', answer: Type.Positive },
              { id: 'ekouprawy/5', answer: Type.Positive },
              { id: 'ekouprawy/6', answer: Type.Negative },
              { id: 'ekouprawy/7', answer: Type.Negative },
              { id: 'ekouprawy/8', answer: Type.Negative },
              { id: 'ekouprawy/9', answer: Type.Negative },
              { id: 'ekouprawy/10', answer: Type.Negative },
            ]
          },
          {
            topic: "Zanieczyszczenia powietrza, ziemi i wody",
            subtitle: "Co zanieczyszcza naszą Ziemię?",
            titles: {
              positive: "To co jej nie zanieczyszcza",
              negative: "To co ją zanieczyszcza"
            },
            items: [
              { id: 'zanieczyszczenia/1', answer: Type.Negative },
              { id: 'zanieczyszczenia/2', answer: Type.Negative },
              { id: 'zanieczyszczenia/3', answer: Type.Negative },
              { id: 'zanieczyszczenia/4', answer: Type.Negative },
              { id: 'zanieczyszczenia/5', answer: Type.Negative },
              { id: 'zanieczyszczenia/6', answer: Type.Positive },
              { id: 'zanieczyszczenia/7', answer: Type.Positive },
              { id: 'zanieczyszczenia/8', answer: Type.Positive },
              { id: 'zanieczyszczenia/9', answer: Type.Positive },
              { id: 'zanieczyszczenia/10', answer: Type.Positive },
            ]
          },
        ],
        '1-4': [
          {
            topic: "Recykling",
            titles: {
              positive: "Co podlega recyklingowi?",
              negative: "Co niepodlega recyklingowi?"
            },
            items: [
              { id: 'recykling/1', answer: Type.Negative },
              { id: 'recykling/2', answer: Type.Negative },
              { id: 'recykling/3', answer: Type.Negative },
              { id: 'recykling/4', answer: Type.Negative },
              { id: 'recykling/5', answer: Type.Negative },
              { id: 'recykling/6', answer: Type.Positive },
              { id: 'recykling/7', answer: Type.Positive },
              { id: 'recykling/8', answer: Type.Positive },
              { id: 'recykling/9', answer: Type.Positive },
              { id: 'recykling/10', answer: Type.Positive },
            ]
          },
          {
            topic: "OZE",
            titles: {
              positive: "Odnawialne źródła energii",
              negative: "Nieodnawialne źródła energii"
            },
            items: [
              { id: 'oze/1', answer: Type.Negative },
              { id: 'oze/2', answer: Type.Negative },
              { id: 'oze/3', answer: Type.Negative },
              { id: 'oze/4', answer: Type.Negative },
              { id: 'oze/5', answer: Type.Negative },
              { id: 'oze/6', answer: Type.Positive },
              { id: 'oze/7', answer: Type.Positive },
              { id: 'oze/8', answer: Type.Positive },
              { id: 'oze/9', answer: Type.Positive },
              { id: 'oze/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Zanieczyszczenie powietrza",
            titles: {
              positive: "Czyste powietrze",
              negative: "Zanieczyszczenie powietrza"
            },
            items: [
              { id: 'zanieczyszczenie/1', answer: Type.Negative },
              { id: 'zanieczyszczenie/2', answer: Type.Negative },
              { id: 'zanieczyszczenie/3', answer: Type.Negative },
              { id: 'zanieczyszczenie/4', answer: Type.Negative },
              { id: 'zanieczyszczenie/5', answer: Type.Negative },
              { id: 'zanieczyszczenie/6', answer: Type.Positive },
              { id: 'zanieczyszczenie/7', answer: Type.Positive },
              { id: 'zanieczyszczenie/8', answer: Type.Positive },
              { id: 'zanieczyszczenie/9', answer: Type.Positive },
              { id: 'zanieczyszczenie/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Emisja gazów i pyłów",
            titles: {
              positive: "Emisja czystego powietrza",
              negative: "Emisja gazów i pyłów"
            },
            items: [
              { id: 'emisja/1', answer: Type.Negative },
              { id: 'emisja/2', answer: Type.Negative },
              { id: 'emisja/3', answer: Type.Negative },
              { id: 'emisja/4', answer: Type.Negative },
              { id: 'emisja/5', answer: Type.Negative },
              { id: 'emisja/6', answer: Type.Positive },
              { id: 'emisja/7', answer: Type.Positive },
              { id: 'emisja/8', answer: Type.Positive },
              { id: 'emisja/9', answer: Type.Positive },
              { id: 'emisja/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Segregacja odpadów",
            titles: {
              positive: "Dobra segregacja odpadów",
              negative: "Zła segregacja odpadów"
            },
            items: [
              { id: 'segregacja/1', answer: Type.Negative },
              { id: 'segregacja/2', answer: Type.Negative },
              { id: 'segregacja/3', answer: Type.Negative },
              { id: 'segregacja/4', answer: Type.Negative },
              { id: 'segregacja/5', answer: Type.Negative },
              { id: 'segregacja/6', answer: Type.Positive },
              { id: 'segregacja/7', answer: Type.Positive },
              { id: 'segregacja/8', answer: Type.Positive },
              { id: 'segregacja/9', answer: Type.Positive },
              { id: 'segregacja/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Ekologiczna gospodarka wodna",
            titles: {
              positive: "Ekologiczna gospodarka wodna",
              negative: "Zanieczyszczona woda"
            },
            items: [
              { id: 'gospodarka-wodna/1', answer: Type.Negative },
              { id: 'gospodarka-wodna/2', answer: Type.Negative },
              { id: 'gospodarka-wodna/3', answer: Type.Negative },
              { id: 'gospodarka-wodna/4', answer: Type.Negative },
              { id: 'gospodarka-wodna/5', answer: Type.Negative },
              { id: 'gospodarka-wodna/6', answer: Type.Positive },
              { id: 'gospodarka-wodna/7', answer: Type.Positive },
              { id: 'gospodarka-wodna/8', answer: Type.Positive },
              { id: 'gospodarka-wodna/9', answer: Type.Positive },
              { id: 'gospodarka-wodna/10', answer: Type.Positive },
            ]
          }
        ],
        '5-8': [
          {
            topic: "Recykling",
            titles: {
              positive: "Co podlega recyklingowi?",
              negative: "Co niepodlega recyklingowi?"
            },
            items: [
              { id: 'recykling/1', answer: Type.Negative },
              { id: 'recykling/2', answer: Type.Negative },
              { id: 'recykling/3', answer: Type.Negative },
              { id: 'recykling/4', answer: Type.Negative },
              { id: 'recykling/5', answer: Type.Negative },
              { id: 'recykling/6', answer: Type.Positive },
              { id: 'recykling/7', answer: Type.Positive },
              { id: 'recykling/8', answer: Type.Positive },
              { id: 'recykling/9', answer: Type.Positive },
              { id: 'recykling/10', answer: Type.Positive },
            ]
          },
          {
            topic: "OZE",
            titles: {
              positive: "Odnawialne źródła energii",
              negative: "Nieodnawialne źródła energii"
            },
            items: [
              { id: 'oze/1', answer: Type.Negative },
              { id: 'oze/2', answer: Type.Negative },
              { id: 'oze/3', answer: Type.Negative },
              { id: 'oze/4', answer: Type.Negative },
              { id: 'oze/5', answer: Type.Negative },
              { id: 'oze/6', answer: Type.Positive },
              { id: 'oze/7', answer: Type.Positive },
              { id: 'oze/8', answer: Type.Positive },
              { id: 'oze/9', answer: Type.Positive },
              { id: 'oze/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Zanieczyszczenie powietrza",
            titles: {
              positive: "Czyste powietrze",
              negative: "Zanieczyszczenie powietrza"
            },
            items: [
              { id: 'zanieczyszczenie/1', answer: Type.Negative },
              { id: 'zanieczyszczenie/2', answer: Type.Negative },
              { id: 'zanieczyszczenie/3', answer: Type.Negative },
              { id: 'zanieczyszczenie/4', answer: Type.Negative },
              { id: 'zanieczyszczenie/5', answer: Type.Negative },
              { id: 'zanieczyszczenie/6', answer: Type.Positive },
              { id: 'zanieczyszczenie/7', answer: Type.Positive },
              { id: 'zanieczyszczenie/8', answer: Type.Positive },
              { id: 'zanieczyszczenie/9', answer: Type.Positive },
              { id: 'zanieczyszczenie/10', answer: Type.Positive },
            ]
          },
          {
            topic: "Emisja gazów i pyłów",
            titles: {
              positive: "Emisja czystego powietrza",
              negative: "Emisja gazów i pyłów"
            },
            items: [
              { id: 'emisja/1', answer: Type.Positive },
              { id: 'emisja/2', answer: Type.Positive },
              { id: 'emisja/3', answer: Type.Positive },
              { id: 'emisja/4', answer: Type.Positive },
              { id: 'emisja/5', answer: Type.Positive },
              { id: 'emisja/6', answer: Type.Negative },
              { id: 'emisja/7', answer: Type.Negative },
              { id: 'emisja/8', answer: Type.Negative },
              { id: 'emisja/9', answer: Type.Negative },
              { id: 'emisja/10', answer: Type.Negative },
            ]
          },
          {
            topic: "Segregacja odpadów",
            titles: {
              positive: "Dobra segregacja odpadów",
              negative: "Zła segregacja odpadów"
            },
            items: [
              { id: 'segregacja/1', answer: Type.Positive },
              { id: 'segregacja/2', answer: Type.Positive },
              { id: 'segregacja/3', answer: Type.Positive },
              { id: 'segregacja/4', answer: Type.Positive },
              { id: 'segregacja/5', answer: Type.Positive },
              { id: 'segregacja/6', answer: Type.Negative },
              { id: 'segregacja/7', answer: Type.Negative },
              { id: 'segregacja/8', answer: Type.Negative },
              { id: 'segregacja/9', answer: Type.Negative },
              { id: 'segregacja/10', answer: Type.Negative },
            ]
          },
          {
            topic: "Ekologiczna gospodarka wodna",
            titles: {
              positive: "Ekologiczna gospodarka wodna",
              negative: "Zanieczyszczona woda"
            },
            items: [
              { id: 'gospodarka-wodna/1', answer: Type.Negative },
              { id: 'gospodarka-wodna/2', answer: Type.Negative },
              { id: 'gospodarka-wodna/3', answer: Type.Negative },
              { id: 'gospodarka-wodna/4', answer: Type.Negative },
              { id: 'gospodarka-wodna/5', answer: Type.Negative },
              { id: 'gospodarka-wodna/6', answer: Type.Positive },
              { id: 'gospodarka-wodna/7', answer: Type.Positive },
              { id: 'gospodarka-wodna/8', answer: Type.Positive },
              { id: 'gospodarka-wodna/9', answer: Type.Positive },
              { id: 'gospodarka-wodna/10', answer: Type.Positive },
            ]
          }
        ],
      }
    }
  },
  computed: {
    selectedGame() {
      if (this.gameIndex === null) {
        return null
      }

      return this.games[this.difficult][this.gameIndex]
    },
    isCompleted() {
      if (this.items.negative.length + this.items.positive.length === this.selectedGame.items.length) {
        return true
      }

      return false
    },
    isValid() {
      if (this.isCompleted === false) {
        return false
      }

      if (this.items.positive.length !== this.items.positive.filter((gameItem) => gameItem.answer === Type.Positive).length) {
        return false
      }

      if (this.items.negative.length !== this.items.negative.filter((gameItem) => gameItem.answer === Type.Negative).length) {
        return false
      }

      return true
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    startGame() {
      const $this = this
      this.gameIndex = getRandomOtherThan(this.gameIndex, 0, this.games[this.difficult].length) - 1
      this.$nextTick(() => {
        $this.items.all = JSON.parse(JSON.stringify(this.selectedGame.items))
        $this.items.all.sort( () => Math.random() - 0.5)
        $this.items.positive = []
        $this.items.negative = []
        $this.started = true
      })
    }
  }
}
</script>

<style>
.game-items.no-items {
  background-image: url(assets/drag_icon.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 90px;
  min-height: 225px;
}
.game-items > div {
  height: 100%;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: transparent ;
}
</style>